import React, { useEffect, useState } from "react";
import NavigationButton from "../../../components/Buttons/NavigationButton";
import UserService from "../../../services/UserService";
import Table from "../../../components/Table/Table";
import { ReactComponent as AddItemIcon } from "../../../assets/icons/add.svg";
import ActionButton from "../../../components/Buttons/ActionButton";
import { useWorker, useWorkers } from "../../../Api/newSockets.api";
import { useHistory, useLocation } from "react-router";
import Search from "../../../components/Search/Search";
import AddButton from "../../../components/Buttons/AddButton";
import Input from "../../../components/DataEntry/Input";
import Modal from "../../../components/Modals/Modal";
import Header from "../../../components/Header/Header";
import data_tab_data from "../../../assets/mockedData/data_tab_data";
import Tabs from "../../../components/Tabs/Tabs";
import { savePathToLocalStorage } from "../../../utils/helpers";

const Workers = () => {
  savePathToLocalStorage();
  const { workers, searchWorkers, connected } = useWorkers();
  const { addWorker } = useWorker();
  console.log(workers);

  const [modalOpen, setModalOpen] = useState(false);
  const [model, setModel] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataTabData, setDataTabData] = useState(data_tab_data);
  const [inputValue, setInputValue] = useState("");

  const history = useHistory();

  //TODO: add TYPE field, and according to that field format rows in table component
  const headers = [
    {
      label: "Name",
      key: "name",
      type: "text",
    },
    {
      label: "Progress",
      key: "progress",
      type: "text",
    },
    {
      label: "Status",
      key: "status",
      type: "badge",
    },
    {
      label: "Date created",
      key: "dateCreated",
      type: "date",
    },
  ];

  const filterWorkers = (searchValue) => {
    setInputValue(searchValue);
  };

  console.log(inputValue);

  useEffect(() => {
    if (!connected) return;
    searchWorkers(inputValue).then((data: any) => console.log(data)).catch(() => {});
  }, [connected, inputValue]);

  const handleSubmitWorker = () => {
    const worker = {
      name: "name",
      dateCreated: new Date(),
      dateModified: new Date(),
    };
    console.log(worker);
    addWorker(worker).then((data: any) => {
      history.push(`/data/worker/${data.id}`);
    });
  };

  const handleNewModel = () => {
    setModalOpen(true);
  };

  const onClose = () => {
    setModalOpen(false);
  };

  const handleDelete = (row) => {
    //TODO
  };

  console.log("workers", workers);
  // console.log("headers", headers);
  const actions = () => <>No actions available</>;

  return (
    <div>
      <Header title="Workers" searchFunction={filterWorkers} />
      <div className="main-content-flex">
        <Tabs data={dataTabData} />
        <div className="section">
          <Table
            items={workers}
            headers={headers}
            // When proper route with component is created, uncomment line below
            // to="data/workers"
            onDelete={handleDelete}
            // actions="workers"
            actions={actions}
            tableName="workers"
          />
        </div>
      </div>
      <Modal
        visible={modalOpen}
        onClose={onClose}
        title="Add new dataset"
        onSubmit={handleSubmitWorker}
        submitLoading={loading}
      >
        <Input
          placeholder="Enter a name"
          // onChange={(name: any) => setName(name)}
        />
        <Input
          placeholder="Enter object"
          // onChange={(object: any) => setObject(object)}
        />
      </Modal>
    </div>
  );
};

export default Workers;
